import http from '@axios'

export function getMailTemplates(params) {
  return http({
    method: 'GET',
    url: 'mailing/templates/',
    params,
  })
}
export function createMailTemplate(data) {
  return http({
    method: 'POST',
    url: 'mailing/templates/',
    data,
  })
}

export function updateMailTemplate(data) {
  return http({
    method: 'PATCH',
    url: `mailing/templates/${data.id}`,
    data,
  })
}

export function deleteMailTemplate(id) {
  return http({
    method: 'DELETE',
    url: `mailing/templates/${id}`,
  })
}

export function getMailTemplateFields() {
  return http({
    method: 'GET',
    url: 'mailing/template-fields/',
  })
}

export function sendMail({ params, data }) {
  return http({
    method: 'POST',
    url: 'mailing/send-sms',
    data,
    params,
    timeout: 0,
  })
}

export function getAutoMail(params) {
  return http({
    method: 'GET',
    url: 'mailing/auto-send/',
    params,
  })
}
export function createAutoMail(data) {
  return http({
    method: 'POST',
    url: 'mailing/auto-send/',
    data,
  })
}

export function updateAutoMail(data) {
  return http({
    method: 'PATCH',
    url: `mailing/auto-send/${data.id}`,
    data,
  })
}

export function deleteAutoMail(id) {
  return http({
    method: 'DELETE',
    url: `mailing/auto-send/${id}`,
  })
}
